import React from "react";
import Styled from "styled-components";
import Footer from "./smsc/Footer";
import Nav from "./smsc/Nav";

const LayoutWrapper = Styled.div`


`;

function Layout(props) {


  return (
    <>

    

        <LayoutWrapper data-scroll-container>
          <main className="bg-[#E6FFF1] min-h-[100vh]">

            <div className="overflow-x-hidden">{props.children}</div>
            <Footer/>

          </main>
        </LayoutWrapper>
   </>
  );
}

export default Layout;
